import AddContentForm from './AddContentForm';

export default AddContentForm;
